import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  role?: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return;
}